export enum ValueChartTimePeriod {
  YTD = 'YTD',
  ThreeYears = '3 yrs',
  FiveYears = '5 yrs',
  All = 'All'
}
